import { Illustration, Text, Title } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { getSafeAreaPaddings } from "@src/appV2/redesign/utils/getSafeAreaPaddings";

export interface StripeAccountVerifiedPageContentProps {
  onConfigurePayoutSettingsClick: () => void;
}

export function StripeAccountVerifiedPageContent(props: StripeAccountVerifiedPageContentProps) {
  const { onConfigurePayoutSettingsClick } = props;

  return (
    <Stack
      sx={(theme) => ({
        flex: 1,
        paddingX: theme.spacing(5),
        paddingTop: theme.spacing(10),
        ...getSafeAreaPaddings({ bottom: true, fallbackBottom: theme.spacing(6) }),
      })}
    >
      <Stack spacing={8} sx={{ alignItems: "center" }}>
        <Illustration type="shift-booked" />
        <Stack spacing={5}>
          <Title variant="h3" component="h3" sx={{ textAlign: "center" }}>
            Your Stripe account is verified!
          </Title>
          <Text
            variant="body2"
            sx={(theme) => ({
              textAlign: "center",
              marginTop: theme.spacing(3),
              color: theme.palette.text.secondary,
            })}
          >
            Now, the final step – choose your payout method and destination in Clipboard.
          </Text>
        </Stack>
      </Stack>

      <Box sx={{ flex: 1 }} />

      <Button fullWidth onClick={onConfigurePayoutSettingsClick}>
        Configure payout settings
      </Button>
    </Stack>
  );
}
